import * as React from 'react';
import { Suspense, memo, lazy } from 'react';
import { Provider } from 'react-redux';

import { createStore } from '../store';
import { useGraphQLClient } from '../../graphql-client';
import { CheckoutProps } from '../types';
import { fillOrder } from '../store/order/actions';
import { ApolloProvider } from '@apollo/react-hooks';
import { GuardedApolloProvider } from '../../GuardedApolloProvider';
import { ErrorManager } from '@entities/error';

const CheckoutWrapper = lazy(() => import('./CheckoutWrapper'));

const Component: React.FC<CheckoutProps> = memo(props => {
	const client = useGraphQLClient();
	const store = createStore();

	if (props.order) {
		store.dispatch(fillOrder(props.order));
	}

	return (
		<ApolloProvider client={client}>
			<Provider store={store}>
				<GuardedApolloProvider client={client}>
					<Suspense fallback={<div />}>
						<CheckoutWrapper orderId={props.orderId} startNewSearch={props.startNewSearch} />
					</Suspense>

					<ErrorManager />
				</GuardedApolloProvider>
			</Provider>
		</ApolloProvider>
	);
});

export default Component;
